module.exports = __webpack_public_path__ + "media/images/appTitle-e1c9c5613e2c453dea154bf801e23996.png";